import {
  Code2,
  Database,
  Heading1,
  Heading2,
  Heading3,
  Heading4,
  Heading5,
  Heading6,
  LucideIcon,
  Type,
  Variable,
} from "lucide-react";
import React from "react";

export interface IconMapping {
  icon: LucideIcon;
  className?: string;
}

const iconRegistry: Record<string, IconMapping> = {
  Snippet: {
    icon: Code2,
  },
  "Dataset Examples": {
    icon: Database,
  },
  "Input Variable": {
    icon: Variable,
  },

  "Heading 1": {
    icon: Heading1,
  },
  "Heading 2": {
    icon: Heading2,
  },
  "Heading 3": {
    icon: Heading3,
  },
  "Heading 4": {
    icon: Heading4,
  },
  "Heading 5": {
    icon: Heading5,
  },
  "Heading 6": {
    icon: Heading6,
  },

  default: {
    icon: Type,
  },
};

const getIconForCommand = (title: string): IconMapping => {
  return iconRegistry[title] || iconRegistry.default;
};

interface CommandIconProps {
  title: string;
  className?: string;
  size?: number;
}

export const CommandIcon: React.FC<CommandIconProps> = React.memo(
  ({ title, className, size = 16 }) => {
    const { icon: Icon, className: iconClassName } = getIconForCommand(title);

    return (
      <Icon
        className={`${iconClassName || ""} ${className || ""}`}
        size={size}
      />
    );
  },
);

CommandIcon.displayName = "CommandIcon";
